import DfpManager from './dfpManager';

export enum ZPG_DFP_NETWORK {
    ID = '9215'
}

export enum AD_UNIT_ROOTS {
    TEXT_LINK = '/ZPG/Zoopla/Text-Links',
    MPU = '/ZPG/Zoopla/MPU',
    MPU_2 = '/ZPG/Zoopla/MPU_2',
    PARTNERSHIP = '/ZPG/Zoopla/Partnership-Ads',
    SKY_SCRAPER = '/ZPG/Zoopla/Skyscraper',
    SKY_SCRAPER_2 = '/ZPG/Zoopla/Skyscraper_2',
    INTERSTITIAL = '/ZPG/Zoopla/Interstitial',
    INLINE = '/ZPG/Zoopla/Inline'
}

export enum AD_UNIT_SECTION {
    TO_RENT = '/To-Rent',
    FOR_SALE = '/For-Sale',
    NEW_HOMES = '/New-Homes',
    HOUSE_PRICES = '/House-Prices',
    UNKNOWN = '/UNKNOWN'
}

export enum AD_UNIT_PAGE {
    LDP = '/ldp',
    LSRP = '/lsrp',
    HOUSE_PRICES = '/house-prices',
    HOMEPAGE = '/home'
}

export enum DFP_AD_UNIT {
    DEFAULT = '/ZPG/Zoopla/for-sale',
    ZOOPLA_LDP_FOR_SALE_DESKTOP = '/sponsorship/zoopla/desktop/for-sale/details',
    ZOOPLA_LDP_FOR_SALE_MOBILE = '/sponsorship/zoopla/mobile/for-sale/details',
    ZOOPLA_LDP_TO_RENT_DESKTOP = '/sponsorship/zoopla/desktop/to-rent/details',
    ZOOPLA_LDP_TO_RENT_MOBILE = '/sponsorship/zoopla/mobile/to-rent/details',
    ZOOPLA_LDP_NEW_HOMES_DESKTOP = '/sponsorship/zoopla/desktop/new-homes/details',
    ZOOPLA_LDP_NEW_HOMES_MOBILE = '/sponsorship/zoopla/mobile/new-homes/details',
    ZOOPLA_LDP_OVERSEAS_DESKTOP = '/sponsorship/zoopla/desktop/overseas/details',
    ZOOPLA_LDP_OVERSEAS_MOBILE = '/sponsorship/zoopla/mobile/overseas/details',
    ZOOPLA_PDP = '/ZPG/Zoopla/Text-Links/House-Prices/Details',
    VALUATION_BOOSTER = '/zoopla-valuation-booster',
    PROJECT_DOORBELL = '/zoopla-project-doorbell'
}

export enum ADBRIDG_CLASS {
    TEXT_LINK_LSRP = 'text_link_lsrp',
    MPU = 'mpu',
    VALUATION_BOOSTER = 'valuation_booster',
    MPU_2 = 'mpu2',
    SKYSCRAPER = 'skyscraper',
    SKYSCRAPER_2 = 'skyscraper2',
    INTERSTITIAL_DESKTOP = 'interstitial_desktop',
    INTERSTITIAL_MOBILE = 'interstitial_mobile',
    SPONSOR_MOBILE = 'sponsor_mobile',
    TEXT_LINK_LDP = 'text_link_ldp',
    SPONSOR_DESKTOP = 'sponsor_desktop',
    TEXT_LINK_MH = 'text_link_mh',
    PROJECT_DOORBELL = 'project_doorbell',
    TEXT_LINK = 'text_link',
    INLINE_SPECIAL = 'inline_special'
}

// Option to include a size or a keyword e.g. 400x400 or 'fluid'
export type Size = [number, number] | 'fluid';
type MediaQueryDirection = '>' | '<';
export type Breakpoint = [MediaQueryDirection, number];

export type GoogleTag = any; // eslint-disable-line @typescript-eslint/no-explicit-any
export type AdBridg = any; // eslint-disable-line @typescript-eslint/no-explicit-any

export type CustomWindow = Window &
    typeof globalThis & {
        googletag: GoogleTag;
        AdBridg: AdBridg;
    };

export type DfpTargeting = {
    [key: string]: string | string[];
};

export type Slot = {
    id: string;
    sizes: Size[];
    adUnitPath: string /* === DfpNetworkId + AdUnitCode */;
    position: number;
    collapseEmpty?: boolean;
    isDefined?: boolean;
    hideFromSizeUp?: number;
    hideFromSizeDown?: number;
};

export type Slots = { [id: string]: Slot };

export type AdvertContextType = {
    dfpInitialised: boolean;
    slots: Slots;
    targeting: DfpTargeting;
    adUnitCode: DFP_AD_UNIT;
    dfpNetworkId: ZPG_DFP_NETWORK.ID;
    showPlaceHolderContent: boolean;
    debugMode: boolean;
    dfpManager?: DfpManager;
    adBridgInitialised: boolean;
};

export enum ACTION_TYPE {
    MOUNT_SLOT = 'MOUNT_SLOT',
    SET_TARGETING = 'SET_TARGETING',
    SET_INITIALISED = 'SET_INITIALISED',
    UNMOUNT_SLOT = 'UNMOUNT_SLOT',
    SET_DFP_MANAGER = 'SET_DFP_MANAGER',
    REFRESH = 'REFRESH',
    SET_SHUTDOWN = 'SET_SHUTDOWN',
    SET_ADBRIDG_INITIALISED = 'SET_ADBRIDG_INITIALISED'
}

export enum ADBRIDG_ACTION {
    SHUTDOWN = 'spa_pv_shutdown',
    INITIALISE = 'spa_pv_initialize'
}

export type AdvertContextAction =
    | { type: ACTION_TYPE.MOUNT_SLOT; payload: Slot }
    | { type: ACTION_TYPE.UNMOUNT_SLOT; payload: { id: string } }
    | { type: ACTION_TYPE.SET_TARGETING; payload: DfpTargeting }
    | { type: ACTION_TYPE.SET_INITIALISED }
    | { type: ACTION_TYPE.SET_ADBRIDG_INITIALISED }
    | { type: ACTION_TYPE.SET_SHUTDOWN }
    | { type: ACTION_TYPE.SET_DFP_MANAGER; payload: DfpManager }
    | { type: ACTION_TYPE.REFRESH };

export enum MOBILE_AD_VARIATE_TYPE {
    EXPERIAN = 'EXPERIAN',
    VARIATION_1 = 'VARIATION_1',
    VARIATION_2 = 'VARIATION_2'
}

export type MobileAdVariations = {
    [MOBILE_AD_VARIATE_TYPE.EXPERIAN]: number;
    [MOBILE_AD_VARIATE_TYPE.VARIATION_1]: number;
    [MOBILE_AD_VARIATE_TYPE.VARIATION_2]: number;
};

export type StyledAdSlotProps = {
    width?: number;
    height?: number;
    breakpoint?: Breakpoint;
};

export type RecordedAdData = {
    creativeId?: number;
    sourceAgnosticCreativeId?: number;
};

export type SlotRenderEndedEvent = {
    slot: {
        getSlotElementId: () => string;
    };
    creativeId?: number;
    sourceAgnosticCreativeId?: number;
};
